import { IFaireMoney } from '../../indigofair/data/IFaireMoney';
import { IGetAchMessagingResponse } from '../../indigofair/data/IGetAchMessagingResponse';

export namespace IAchLinkingOfferEligibilityResponse {
  export type AchOfferSurfaceType =
    | 'ACH_OFFER_SURFACE_UNKNOWN'
    | 'ACCOUNT_DROPDOWN'
    | 'CHECKOUT'
    | 'PROMO_MODAL';

  /**
   * for the current retailer session, show the eligibility for an ACH linking offer
   */
  export enum AchOfferSurface {
    ACH_OFFER_SURFACE_UNKNOWN = 'ACH_OFFER_SURFACE_UNKNOWN',
    ACCOUNT_DROPDOWN = 'ACCOUNT_DROPDOWN',
    CHECKOUT = 'CHECKOUT',
    PROMO_MODAL = 'PROMO_MODAL',
  }

  /**
   * Return an instance of IAchLinkingOfferEligibilityResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IAchLinkingOfferEligibilityResponse>
  ): IAchLinkingOfferEligibilityResponse =>
    ({
      claimed_offers: [],
      ...(partial ?? {}),
    }) as IAchLinkingOfferEligibilityResponse;
}

export interface IAchLinkingOfferEligibilityResponse {
  is_eligible: boolean | undefined;
  /**
   * @deprecated
   */
  has_linked_ach: boolean | undefined;
  current_terms_limit: IFaireMoney | undefined;
  offer_boost_limit: IFaireMoney | undefined;
  ach_offer_type:
    | keyof typeof IGetAchMessagingResponse.AchOfferType
    | undefined;
  has_linked_plaid_ach_as_default: boolean | undefined;
  plaid_ach_instrument_token_to_as_default: string | undefined;
  claimed_offers: Array<keyof typeof IGetAchMessagingResponse.AchOfferType>;
}
